import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { axiosGet } from "../../util/axios";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import {
    Button,
    FormControlLabel,
    Grid,
    InputLabel,
    Radio,
    RadioGroup,
} from "@mui/material";
import { EditNote } from "@mui/icons-material";
import FormDialog from "../../component/common/FormDialog";
import { getAllDatesInYear } from "../../util/date";
import { CollectionPeriod } from "../../interface/collection";
import { initCollectRouteListThunk } from "../../redux/route/thunk";
import CollectionRoute from "../../component/collection/CollectionRoute";
import { DatePicker } from "@mui/x-date-pickers";
import styles from "./collection.module.css";
import { infoCatelogType } from "../../interface/form";
import { handleDownLoadExcel } from "../../util/excel";
import { isGovernemnt } from "../../util/form/form";
import { excelType } from "../../interface/collection";

function Collection() {
    const [detailDialog, setDetailDialog] = useState<boolean>(false);
    const [clickExcelBtn, setClickExcelBtn] = useState<boolean>(false);
    const [excelType, setExcelType] = useState<excelType>("collection");
    const { user } = useSelector((state: IRootState) => state.userAuth);
    const isGovernmentRole = isGovernemnt(user?.token?.role_id as number);
    const [excelDownloadStartDate, setExcelDownloadStartDate] = useState<
        moment.Moment | Date | null
    >(null);
    const [excelDownloadEndDate, setExcelDownloadEndDate] = useState<
        moment.Moment | Date | null
    >(null);
    const [dataArray, setDataAray] = useState([{ id: 0 }]);

    const dispatch = useDispatch<IRootThunkDispatch>();

    useEffect(() => {
        const currentYear = moment().year();
        const datesInYear = getAllDatesInYear(currentYear);
        const dataArrayList = datesInYear.map((item, index) => ({
            id: index,
            date: item,
            weekday: new Date(item).toLocaleString("en-US", {
                weekday: "long",
            }),
        }));
        setDataAray(dataArrayList);
    }, []);

    async function handleClickCollectionDetailButton(
        collection: CollectionPeriod
    ) {
        dispatch(OpenLoadingBarThunk(true));
        const result = await axiosGet(
            `/api/collection/?date=${collection.date}&weekday=${collection.weekday}`
        );
        dispatch(OpenLoadingBarThunk(false));
        if (result.data.success) {
            dispatch(initCollectRouteListThunk(result.data.routeList));
            setDetailDialog(true);
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得詳情資料"));
        }
    }

    function handleCloseDialog() {
        setDetailDialog(false);
    }

    function handleClickExcelBtn() {
        setClickExcelBtn(!clickExcelBtn);
    }

    function handleDownloadStartDate(date: moment.Moment | Date | null) {
        setExcelDownloadStartDate(date);
    }

    function handleDownloadEndDate(date: moment.Moment | Date | null) {
        setExcelDownloadEndDate(date);
    }

    function DownloadExcel(type: infoCatelogType) {
        if (excelDownloadStartDate && excelDownloadEndDate) {
            handleDownLoadExcel(
                dispatch,
                type,
                excelDownloadStartDate as Date,
                excelDownloadEndDate as Date
            );
        } else {
            dispatch(OpenSnackBarWithResultFail("未有填寫開始及完結日期"));
        }
    }

    const columns: GridColDef[] = [
        { field: "id", headerName: "日子編號", width: 70, flex: 1 },
        {
            field: "date",
            headerName: "日期",
            width: 300,
            flex: 2,
            valueGetter: (params) =>
                params.row.date
                    ? moment(params.row.date).format("YYYY-MM-DD")
                    : null,
        },
        { field: "weekday", headerName: "工作日", flex: 1 },
        {
            field: "action",
            headerName: "詳情",
            flex: 1,
            renderCell: (data) => {
                return data.row.contract_id === 1 ? (
                    <></>
                ) : (
                    <Button
                        variant="contained"
                        onClick={() =>
                            handleClickCollectionDetailButton(data.row)
                        }
                    >
                        <EditNote />
                        <Grid>詳情</Grid>
                    </Button>
                );
            },
        },
    ];

    return (
        <>
            <>
                <Grid className={styles.excelBtnOuterContainer}>
                    <Button variant="contained" onClick={handleClickExcelBtn}>
                        Excel
                    </Button>
                </Grid>
            </>

            {clickExcelBtn ? (
                <Grid className={styles.excelTimeOuterContainer}>
                    {!isGovernmentRole && (
                        <Grid>
                            <RadioGroup
                                value={excelType}
                                onChange={(e) =>
                                    setExcelType(e.target.value as excelType)
                                }
                            >
                                <FormControlLabel
                                    value={"collection"}
                                    control={<Radio />}
                                    label="收集紀錄"
                                ></FormControlLabel>
                                <FormControlLabel
                                    value={"excel"}
                                    control={<Radio />}
                                    label="電郵紀錄"
                                ></FormControlLabel>
                            </RadioGroup>
                        </Grid>
                    )}
                    <Grid>
                        <InputLabel htmlFor="enquiry-date-picker">
                            開始時間
                        </InputLabel>
                        <DatePicker
                            onChange={(data) =>
                                handleDownloadStartDate(data! as Date)
                            }
                            value={excelDownloadStartDate}
                            format="YYYY-MM-DD"
                        />
                    </Grid>
                    <Grid>
                        <InputLabel htmlFor="enquiry-date-picker">
                            完結時間
                        </InputLabel>
                        <DatePicker
                            onChange={(data) =>
                                handleDownloadEndDate(data! as Date)
                            }
                            value={excelDownloadEndDate}
                            format="YYYY-MM-DD"
                        />
                    </Grid>

                    <Grid>
                        <Button
                            variant="contained"
                            onClick={() => {
                                if (isGovernmentRole) {
                                    DownloadExcel("Epd");
                                } else {
                                    if (excelType === "collection") {
                                        DownloadExcel("Collection");
                                    } else {
                                        DownloadExcel("EmailRecords");
                                    }
                                }
                            }}
                        >
                            下載
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <></>
            )}

            <div style={{ height: "900px", width: "100%" }}>
                <DataGrid
                    rows={dataArray || []}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 30 },
                        },
                    }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                />
            </div>

            <FormDialog
                title="詳細情況"
                open={detailDialog}
                handleClose={handleCloseDialog}
                size="lg"
            >
                {/* <CollectionDetail /> */}
                <CollectionRoute />
            </FormDialog>
        </>
    );
}

export default Collection;
